import React, { Component } from "react";
import { AgGridReact } from "ag-grid-react";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import {
  ExpansionPanel,
  ExpansionPanelDetails,
  ExpansionPanelSummary,
} from "../../Expand";
import { filter, get, union, uniqBy, orderBy } from "lodash";

import { getTotalOrderPromo, getOldListPromo } from "../HeaderOrdersItem";

import { getNumber, defaultColumnSp } from "../utils";

class GridPromoSpecialPrice extends Component {
  constructor(props) {
    super(props);

    const { item, formData, products } = props;

    // const { Criteria, Match } = item
    // let listProduct = filter(product, function (o) {
    //   return o[Criteria] === Match
    // })

    let listProduct = filter(products, function (o) {
      return o.subgroup_id === item.criteria.price.buy.id;
    });
    if (get(item, "criteria.price.buy.type", "") === "ProductCode") {
      listProduct = filter(products, function (o) {
        return o.code === item.criteria.price.buy.id;
      });
    } else if (get(item, "criteria.price.buy.type", "") === "ProductGroup") {
      listProduct = filter(products, function (o) {
        return o.group_id === item.criteria.price.buy.id;
      });
    } else if (
      get(item, "criteria.price.buy.type", "") === "ProductShortCode"
    ) {
      listProduct = filter(products, function (o) {
        return o.short_code === item.criteria.price.buy.id;
      });
    }

    const listPromo = get(formData, "items", []);
    const allTotal = getTotalOrderPromo(listPromo, item);
    const latestListPromo = getOldListPromo(listPromo, item);

    if (latestListPromo) {
      const data = union(latestListPromo.listSp, listProduct);
      listProduct = uniqBy(data, "code");
    } else {
      listProduct = filter(products, function (o) {
        if (o.subgroup_id === item.criteria.price.buy.id) {
          o.SpecialPrice = 0;
          o.OrderAmt = 0;
          return o.subgroup_id === item.criteria.price.buy.id;
        } else if (o.code === item.criteria.price.buy.id) {
          o.SpecialPrice = 0;
          o.Order = 0;
          o.OrderAmt = 0;
          return o.code === item.criteria.price.buy.id;
        } else if (o.group_id === item.criteria.price.buy.id) {
          o.SpecialPrice = 0;
          o.Order = 0;
          o.OrderAmt = 0;
          return o.group_id === item.criteria.price.buy.id;
        } else if (o.short_code === item.criteria.price.buy.id) {
          o.SpecialPrice = 0;
          o.Order = 0;
          o.OrderAmt = 0;
          return o.short_code === item.criteria.price.buy.id;
        }
        return false;
      });
    }
    this.state = {
      search: "",
      message: "",
      show: false,
      rowData: listProduct,
      columnDefs: defaultColumnSp,
      defaultColDef: {
        flex: 1,
        editable: true,
        sortable: true,
        filter: true,
        cellStyle: {
          "line-height": "40px",
        },
      },
      getRowNodeId: function (data) {
        return data.code;
      },
      listPromo: get(latestListPromo, "listSp", []),
      item: props.item,
      tPromoOrderQty: allTotal.totalOrderQty,
      tPromoOrderAmt: allTotal.totalOrderAmt,
      expanded: "panelGridPromoSpecialPrice",
      moqSelected: 0,
    };
  }

  onGridReady = (params) => {
    this.gridApiSpecialPrice = params.api;
    this.gridColumnApiDiscount = params.columnApi;
  };

  onCellChanged(params, locale) {
    locale.onUpdateItem(params);
    // locale.props.onUpdatePromoProduct(params)
  }
  onGetMOQ = (qty) => {
    let special_price = 0;
    const { item } = this.props;
    const moqs = orderBy(
      get(item, "criteria.price.moqs", []),
      ["moq"],
      ["desc"]
    );

    if (moqs.length > 0) {
      if (qty >= moqs[0].moq) {
        return moqs[0].price;
      } else if (qty >= moqs[1].moq) {
        return moqs[1].price;
      } else if (qty >= moqs[2].moq) {
        return moqs[2].price;
      }
    }

    return special_price;
  };
  onGetSpecialPrice = (qty) => {
    let special_price = 0;
    const { item } = this.props;
    const moqs = orderBy(
      get(item, "criteria.price.moqs", []),
      ["moq"],
      ["desc"]
    );
    if (moqs.length > 0) {
      if (qty >= moqs[0].moq) {
        const myTotalResult =
          moqs[0].price !== "" && moqs[0].price > 0
            ? Number(moqs[0].price).toFixed(2)
            : 0;
        return myTotalResult;
      } else if (qty >= moqs[1].moq) {
        const myTotalResult =
          moqs[1].price !== "" && moqs[1].price > 0
            ? Number(moqs[1].price).toFixed(2)
            : 0;
        return myTotalResult;
      } else if (qty >= moqs[2].moq) {
        const myTotalResult =
          moqs[2].price !== "" && moqs[2].price > 0
            ? Number(moqs[2].price).toFixed(2)
            : 0;
        return myTotalResult;
      }
    }

    return special_price;
  };

  onUpdateItem = (params) => {
    if (params.data.Order && params.data.Order > 0) {
      const { listPromo } = this.state;
      let newListPromo = listPromo;
      // const DiscValue = ""

      const values = {
        ...params.data,
      };

      if (newListPromo.length === 0) {
        newListPromo.push(values);
      } else {
        let newList = filter(newListPromo, function (o) {
          return o.code !== params.data.code;
        });
        newListPromo = newList;
        newListPromo.push(values);
      }
      const tpoq = getNumber(newListPromo, "tPromoOrderQty");
      const tpoqa = getNumber(newListPromo, "tPromoOrderAmt");
      const valueDisc = this.onGetSpecialPrice(tpoq);
      if (this.state.moqSelected !== this.onGetMOQ(tpoq)) {
        this.setOrderDefaultList(parseFloat(valueDisc), this.onGetMOQ(tpoq));
      }
      this.setOrderAmtDefault(params.data.code, params.data);
      // this.setOrderDefault(params.data.ProductCode)

      this.setState({
        listPromo: newListPromo,
        tPromoOrderQty: tpoq,
        tPromoOrderAmt: tpoqa,
      });
      this.props.onUpdatePromoProduct(newListPromo, tpoq, tpoqa);
    }
  };

  handleChange = (panel) => (event, newExpanded) => {
    this.setState({
      expanded: newExpanded ? panel : false,
    });
  };

  setOrderDefault(ProductCode, value) {
    if (ProductCode) {
      var rowNode = this.gridApiSpecialPrice.getRowNode(ProductCode);
      rowNode.setDataValue("SpecialPrice", value);
    }
  }
  setOrderAmtDefault(ProductCode, item) {
    if (ProductCode) {
      var rowNode = this.gridApiSpecialPrice.getRowNode(ProductCode);
      rowNode.setDataValue(
        "OrderAmt",
        Number(item.Order * item.price).toFixed(2)
      );
    }
  }
  setOrderDefaultList(value, moq) {
    const { rowData } = this.state;
    rowData.map((discount) => {
      if (discount.code) {
        var rowNode = this.gridApiSpecialPrice.getRowNode(discount.code);
        rowNode.setDataValue("SpecialPrice", value);
      }
      return "";
    });
    this.setState({ moqSelected: moq });
  }

  render() {
    const { translate } = this.props;

    return (
      <ExpansionPanel
        expanded={this.state.expanded === "panelGridPromoSpecialPrice"}
        onChange={this.handleChange("panelGridPromoSpecialPrice")}
      >
        <ExpansionPanelSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls='promotion_items-special-price-content'
          id='promotion_items-special-price-header'
        >
          <Typography>
            {translate("resources.po.listgrid.label.promo_items")} (
            {this.state.rowData.length}{" "}
            {this.state.rowData.length > 1
              ? translate("resources.po.listgrid.label.items")
              : translate("resources.po.listgrid.label.item")}
            )
          </Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails
          style={{ width: "100%%", padding: 0, paddingTop: 4 }}
        >
          <div style={{ width: "100%", height: "100%" }}>
            <div className='grid-wrapper'>
              <div
                id='myGrid'
                style={{
                  height: "55vh",
                  width: "100%",
                }}
                className='ag-theme-balham'
              >
                <AgGridReact
                  rowHeight={40}
                  headerHeight={40}
                  rowData={this.state.rowData}
                  columnDefs={this.state.columnDefs}
                  defaultColDef={this.state.defaultColDef}
                  animateRows={true}
                  getRowNodeId={this.state.getRowNodeId}
                  onGridReady={this.onGridReady}
                  onCellValueChanged={(params) =>
                    this.onCellChanged(params, this)
                  }
                />
              </div>
            </div>
          </div>
        </ExpansionPanelDetails>
      </ExpansionPanel>
    );
  }
}

export default GridPromoSpecialPrice;
